module.exports = __webpack_public_path__ + "img/18.8b24e337.jpg";